
<template>
  <div class="header_fxed _width">
    <div class="header_center ">
      <div class="header_logo fl login_hide">
        <img src="@/assets/image/logo.png"
             alt="">
      </div>
      <!-- 导航 -->
      <ul class="navList fl clearfix mobile login_hide">
        <!-- 导航开始 -->
        <li class="active">
          <a :href="`${path}`">首页</a>
        </li>
        <li id="secondNav">
          <a :href="`${path}pages/pc/pictures/index.html`">图片</a>
        </li>
        <li>
          <a :href="`${path}pages/pc/video/index.html`">视频</a>
        </li>
        <li>
          <a :href="`${path}pages/pc/rMedia/index.html`">融媒体</a>
        </li>
        <li>
          <a :href="`${path}pages/pc/exhibition/index.html`">展厅</a>
        </li>
        <li>
          <a :href="`${path}pages/pc/live/index.html`">直播</a>
        </li>
        <li>
          <router-link to="/activity_index">活动</router-link>
        </li>
        <li>
          <router-link to="/community">社区</router-link>
          <!-- <a href=" http://localhost:8080/#/community" target="_blank">社区</a> -->
        </li>
      </ul>
      <!-- 导航 end-->

      <!-- header_right -->
      <div class="header_right _height fr mobile ">

        <!-- 搜索 -->
        <div class="search_box fl _height  tg_se_style login_hide">
          <!-- 搜索未点击 -->
          <a href="javascript:;"
             @click="on_search()"
             class="tgA">
            <img src="@/assets/image/header/search1.png"
                 title="搜索">
            搜索
          </a>
          <!-- 搜索未点击 end-->
          <!-- 搜搜索点击后 v-if="search_show == true"-->
          <div class="search_cilck"
               :class="search_show ===true ? 'active_search_box' : '' ">
            <div class="header-filter1">
              <!--  -->
              <div class="select-val1"
                   :class="search_show ===true ? 'active_search' : '' ">

                <el-select v-model="search_select_data"
                           :class="search_show ===true ? 'active_search' : '' "
                           placeholder="全部"
                           popper-class="tag_select">
                  <el-option v-for="item in options"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>

              </div>

              <input type="text"
                     name="type"
                     class="search_input"
                     placeholder="请输入关键字"
                     v-model="search_val"
                     @keyup.enter="hide_search"
                     :class="search_show ===true ? 'active_input' : '' ">

              <!-- 搜索按钮 -->
              <i :class="search_show ===true ? 'active_btn' : '' ">
                <a href="javascript:;"
                   class="searchBtn"
                   @click="hide_search()">
                  <img src="@/assets/image/header/search.png"
                       title="搜索">
                  搜索
                </a>
              </i>
              <!-- 搜索按钮 end-->
            </div>
          </div>
          <!-- 搜搜索点击后 end-->
        </div>
        <!-- 搜索 -->

        <!-- 投稿 -->
        <div class="up_works fl _height tg_se_style login_hide">
          <a href="https://v.jingjiribao.cn/manu/manuEntry?activeId="
             class="tgA">
            <img src="@/assets/image/header/tg32.png"
                 title="供稿">
            供稿
          </a>
        </div>
        <!-- 投稿 -->

        <!-- 登录状态 -->
        <!-- 未登录 v-show="!loginid" -->

        <!-- v-if="!loginid" -->
        <div class="i_login _height fr"
             v-if="isLogin == false">

          <a href="javascript:;"
             @click="on_tab(1)">登录</a>
          <!-- :class="this.$route.query.state == 1?'activeTab':''" -->
          <span>|</span>
          <a href="javascript:;"
             @click="on_tab(2)">注册</a>
          <!-- :class="this.$route.query.state == 2?'activeTab':''" -->
        </div>
        <!-- 未登录 end-->

        <!-- 已登录  v-show="loginid"-->
        <div class="else_login _height fr"
             v-if="isLogin == true">
          <div class="loginSuccessBar clearfix  fr">
            <a href="javascript:;"
               class="userName">
              <img src="@/assets/image/header/arrow.png"
                   class="usersj">
              <span class="userNameSpan"
                    v-if="isLogin_user.realname">{{isLogin_user.realname }}</span>
              <img :src="isLogin_user.headimg"
                   class="userHeadImg"
                   v-if="isLogin_user.headimg">

              <img src="@/assets/image/common/nan.png"
                   class="userHeadImg"
                   v-else>

            </a>
            <ul class="optionsBox_lb hidden">
              <li>
                <a style="font-size:14px;"
                   href="https://v.jingjiribao.cn/user/personInfo">
                  <span class="perLi"><img src="@/assets/image/header/perBtn1.png"></span>个人信息</a>
              </li>

              <li>
                <router-link to="/Pcenter?type=0"
                             style="font-size:14px;">
                  <span class="perLi"><img src="@/assets/image/header/kongjian.png"></span>我的空间
                </router-link>
              </li>

              <li><a style="font-size:14px;"
                   href="https://v.jingjiribao.cn/community/message.html">
                  <span class="perLi">
                    <img src="@/assets/image/header/perBtn2.png">
                    <i class="msgFlag"
                       v-if="tips == true"></i>
                  </span>我的消息</a></li>
              <li><a style="font-size:14px;"
                   href="https://v.jingjiribao.cn/manu/toSinglePic"><span class="perLi"><img
                         src="@/assets/image/header/perBtn3.png"></span>我的投稿</a></li>
              <li><a style="font-size:14px;"
                   href="https://v.jingjiribao.cn/user/collectpage"><span class="perLi"><img
                         src="@/assets/image/header/perBtn4.png"></span>我的收藏</a></li>
              <li @click="out()"><a style="font-size:14px;"
                   href="javascript:;"
                   class="loginOutBtn"><span class="perLi"><img src="@/assets/image/header/perBtn5.png"></span>退出登录</a>
              </li>
              <div class="litterTri"></div>
            </ul>
          </div>
        </div>

        <!-- 已登录 end-->

        <!-- 登录状态 end-->

      </div>
      <!-- header_right -->
    </div>
    <div class="mohu">
    </div>

  </div>

</template>

<script >
import { Info, ismsg, logout } from '@/utils/api/login.js'
export default {
  props: ["router_url"],
  data () {
    return {
      tips: false,//false：没消息 true：有消息时候
      search_show: false,//false 隐藏  true 显示搜索框
      search_val: '',//搜索框对值
      // 搜索框下啦数据
      search_select_data: '全部',//seelct的value
      options: [{
        value: '100',
        label: '全部'
      }, {
        value: '101',
        label: '图片'
      }, {
        value: '103',
        label: '视频'
      }, {
        value: '105',
        label: '融媒体'
      }, {
        value: '110',
        label: '展厅'
      }, {
        value: '108',
        label: '直播'
      }, {
        value: '109',
        label: '活动'
      }, {
        value: '106',
        label: '社区'
      },
      ],
      // loginid: this.$store.state.id,
      // headimg: sessionStorage.getItem("headimg"),
      // loginName: sessionStorage.getItem("realname"),
      isLogin: '',
      isLogin_user: {},
      path: this.URL.pc_url,

    };
  },

  watch: {
    '$store.state.id': function () {
      this.loginid = this.$store.state.id || sessionStorage.getItem("id");
      this.headimg = sessionStorage.getItem("headimg");
      this.loginName = sessionStorage.getItem("realname")
    }
  },
  mounted () {
    // this.loginid = sessionStorage.getItem("id");
    // this.headimg = sessionStorage.getItem("headimg");
    // this.loginName = sessionStorage.getItem("realname")
    // if (this.loginid = sessionStorage.getItem("id")) {
    //   this.ismsg();//消息
    // }
  },
  created () {
    this.is_login();//登录方法
  },
  methods: {

    // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin
        if (this.isLogin == true) {
          this.isLogin_user = data.user
          this.ismsg();//消息
        }
      })
    },


    // 切换登录注册
    on_tab (index) {
      this.tab = index;
      sessionStorage.setItem('router_url', this.router_url)//

      if (index == 1) {

        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      } else if (index == 2) {

        this.$router.push(
          {
            path: '/login/?state=' + 2,
          }
        )
      }
    },


    // 退出登录
    out () {
      this.loginid = "";
      this.headimg = "";
      this.loginName = "";
      this.$store.commit('id', "");
      this.$store.commit('headimg', "");
      this.$store.commit('realname', "");
      sessionStorage.clear();
      logout().then((res) => {
        let data = res.data;
        console.log(data);
        if (data.status == 200) {
          // this.$message({
          //   message: '退出成功',
          //   type: 'success'
          // })
          this.is_login();//登录方法
        }
      })
      // //清除页面所有localStorage，退出登录
      // // this.$router.push({ path: '/login/?state=' + 1 })
    },


    // 消息
    async ismsg (name) {
      let { data } = await ismsg(name);
      if (data.status == 200 && data.msgNum > 0) {
        this.tips = true
      }
    },
    // 点击搜索显示  搜索框
    on_search () {
      this.search_show = true
    },

    // 搜索功能活着隐藏 
    hide_search () {
      if (this.search_val.length == 0) {
        // 隐藏关闭搜索框
        this.search_show = false
        // 清空select 和输入框
        this.search_select_data = ''
        this.search_val = ''

        return false
      } else {
        // alert('选择的是' + this.search_select_data + '输入的是' + this.search_val)
        let val = encodeURIComponent(this.search_val);
        let type = encodeURIComponent(this.search_select_data);
        val = encodeURIComponent(val);
        type = encodeURIComponent(type);
        window.open(`https://v.jingjiribao.cn/pages/pc/searchResult/index.html?title=${val}&type=${type}`);
        this.search_val = ""
        // 隐藏关闭搜索框
        this.search_show = false
      }
    },
  }
};
</script>

<style lang="">
.tag_select .el-scrollbar {
  border-radius: 4px;
  overflow: hidden;
}
.tag_select .selected span {
  color: #fff !important;
}
</style>
<style scoped>
@import "../../assets/css/common/header.css";

.search_input input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: red;
}
.search_input input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: red;
}
.search_input input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: red;
}
.search_input input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: red;
}
</style>




// WEBPACK FOOTER //
// src/components/common/header.vue